/**
 * 全局弹窗
 * @type {{}}
 */

const noticeDefaultState = {
  visible: false,
  title: '',
  content: '',
  width: 532,
  ok: {
    showBtn: true,
    text: '确认',
    handler: () => {}
  },
  cancel: {
    showBtn: true,
    text: '取消',
    handler: () => {}
  }
};

const initState = {
  setPayPwd: {
    visible: false,
    phoneNo: '',
  },
  setLoginPwd: {
    visible: false,
    phoneNo: '',
    resetType: 1,
  },
  managerList: [],
  fileOversizeOpt: {
    visible: false,
    maxSize: 15,
    fileList: []
  },
  commonNoticeDialogOpt: noticeDefaultState,
  ignoreNoticeDialog: {
    show: false,
    list: [],
    total: 0,
    importantCount: 0,
    secondaryCount: 0
  },
  noticeRefreshFlag: false
};

const actions = {

};

const mutations = {
  updateSetPayPwdModal(state, payload) {
    state.setPayPwd = {
      ...state.setPayPwd,
      ...payload,
    };
  },
  updateSetLoginPwdModal(state, payload) {
    state.setLoginPwd = {
      ...state.setLoginPwd,
      ...payload,
    };
  },
  updateManagerList(state, payload) {
    state.managerList = payload || [];
  },
  updateFileOversizeOpt(state, payload) {
    state.fileOversizeOpt = {
      ...state.fileOversizeOpt,
      ...payload,
    };
  },
  addOversizeFileList(state, payload) {
    state.fileOversizeOpt.fileList.push(payload);
  },
  updateCommonNoticeDialogOpt(state, payload) {
    state.commonNoticeDialogOpt = {
      ...state.commonNoticeDialogOpt,
      ...payload,
    };
  },
  closeCommonNoticeDialog(state) {
    state.commonNoticeDialogOpt = { ...noticeDefaultState };
  },
  updateIgnoreNoticeDialog(state, payload) {
    state.ignoreNoticeDialog = {
      ...state.ignoreNoticeDialog,
      ...payload
    };
  },
  updateNoticeRefreshFlag(state, payload = false) {
    state.noticeRefreshFlag = payload;
  }
};

export default {
  namespaced: true,
  mutations,
  actions,
  state: initState
};
